import React from 'react';
import { useTranslation } from 'react-i18next';
import assets from '../../utils/assets';
import { useRestaurant } from '../../utils/contexts/restaurant-context';
import theme from '../../utils/theme';

export default function PreferredDefaultScreen() {
    const { t } = useTranslation();

    const { restaurant } = useRestaurant();

    return (
        <div className="preferred-default-screen px-4">
            <p className="font-semibold">{t("preferreddefaultscreen.p_1")}</p>
            <p className="mt-4">{theme.getCustomElement(restaurant.id, "preferreddefaultscreen", t)}</p>

            <img src={assets.assetsPath("images/preferred.png")} alt={t("preferreddefaultscreen.img_1")} />
        </div>
    );
}
